import React from 'react';
import IconComponent from '../icons';

const DisplayTickIcon =(flag)=>{
  const value = flag.toLowerCase();
  switch (value) {
    case 'optional' : return(<span className='text-ek-red'>{flag}</span>); 
    case 'available' : return(<div className='h-[32px] w-[32px]'><IconComponent icon='tick' className="text-ek-red" /></div>); 
    case 'doubleasterik': return(<div className='h-[32px] w-[32px] text-ek-red  items-center justify-center flex'>**</div>);
    default : return(<div className='h-[32px] w-[32px]'></div>);
  }
}

export default DisplayTickIcon;
